module.exports = __webpack_public_path__ + "static/media/GMBack-2.51ca606c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GMBack-2.jpg
// module id = 1151
// module chunks = 0